import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'put'

export default class OspreyTemplatesUpdate extends BaseAction {
    constructor(dataKey) {
        const id = '81adff90-096a-43c7-8682-404f9d34e49b'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    update(template) {
        if (!template) {
            throw new Error('Missing template object')
        }

        this.path = `/${resource}/${template.id.value}`

        this.params = {
            template
        }
        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-update.js